/**
 * Shared tab definitions for competitive session navigation (tab bar above content).
 */

export function buildSessionTabs({
  showManageTab,
  isSessionHost,
  isAdmin,
  showYouTab = false,
  showRankingTab = true,
  showPlayerRankingTab = true,
}) {
  const liveTabs = [
    { id: 'courts', label: 'Courts', mobileLabel: 'Courts' },
    ...(showManageTab ? [{ id: 'manage', label: 'Manage', mobileLabel: 'Manage' }] : []),
  ];
  const insightTabs = [
    ...(showRankingTab ? [{ id: 'ranking', label: 'Session Ranking', mobileLabel: 'Sess. rank' }] : []),
    ...(showPlayerRankingTab && isSessionHost && isAdmin
      ? [{ id: 'playerRanking', label: 'Player Ranking', mobileLabel: 'P. rank' }]
      : []),
    { id: 'games', label: 'Games', mobileLabel: 'Games' },
  ];
  const personalTabs = showYouTab
    ? [{ id: 'you', label: 'My Session', mobileLabel: 'You' }]
    : [];
  return [...liveTabs, ...personalTabs, ...insightTabs];
}
